import { useState } from "react";
import type { EventOccurrence } from "@shared/types";
import { Modal } from "./ui/Modal";
import { Button } from "./ui/Button";

interface DeleteEventDialogProps {
  occurrence: EventOccurrence | null;
  onCancel: () => void;
  onConfirm: (scope: "occurrence" | "series") => void;
}

export function DeleteEventDialog({ occurrence, onCancel, onConfirm }: DeleteEventDialogProps) {
  const [scope, setScope] = useState<"occurrence" | "series">("occurrence");
  if (!occurrence) return null;
  const isRecurring = Boolean(occurrence.rrule);

  return (
    <Modal open={Boolean(occurrence)} onClose={onCancel} width="sm">
      <div className="p-6">
        <h2 className="text-lg font-semibold">Delete "{occurrence.title}"?</h2>
        <p className="mt-2 text-sm text-muted dark:text-muted-dark">This can't be undone.</p>

        {isRecurring && (
          <div className="mt-4 flex gap-2">
            <button
              onClick={() => setScope("occurrence")}
              className={`flex-1 rounded-lg border px-3 py-2 text-sm font-medium ${scope === "occurrence" ? "border-accent bg-accent/10 text-accent" : "border-line dark:border-line-dark text-muted dark:text-muted-dark"}`}
            >
              Just this event
            </button>
            <button
              onClick={() => setScope("series")}
              className={`flex-1 rounded-lg border px-3 py-2 text-sm font-medium ${scope === "series" ? "border-accent bg-accent/10 text-accent" : "border-line dark:border-line-dark text-muted dark:text-muted-dark"}`}
            >
              Entire series
            </button>
          </div>
        )}

        <div className="mt-6 flex justify-end gap-3">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => onConfirm(scope)}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
